export const updateFilterSettings =
  ({ filterId, name, value }) =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_FILTER_SETTINGS',
      data: { filterId, name, value },
    });
  };
